import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    background: 'rgba(255,255,255,0.6)',
    position: 'absolute',
    top: '0px',
    left: '0px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 100,
  },
  progress: {
    color: '#000',
  },
});

class TableProgress extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
  };

  render() {
    const { classes } = this.props;
    return (
      <section className={classes.root}>
        <CircularProgress className={classes.progress} size={70} />
      </section>
    );
  }
}

export default styled(TableProgress)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Table/components/TableProgress.js